import { create } from 'zustand';

type MenuStore = {
  isMenuOpen: boolean;
  selectedMenuItem: string;
  isMobileMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  setSelectedMenuItem: (menuItem: string) => void;
  setIsMobileMenuOpen: (isOpen: boolean) => void;
};

export const useMenuStore = create<MenuStore>((set) => ({
  isMenuOpen: true,
  selectedMenuItem: '',
  isMobileMenuOpen: false,
  setIsMenuOpen: (isOpen) => set({ isMenuOpen: isOpen }),
  setSelectedMenuItem: (menuItem) => set({ selectedMenuItem: menuItem }),
  setIsMobileMenuOpen: (isOpen) => set({ isMobileMenuOpen: isOpen }),
}));
